module.exports = __webpack_public_path__ + "img/P.3da028f.webp";